import { api } from './index';

const LoginService = {
  login: async(email, password) => {
    let response = await api.post('/login', {
      email: email,
      password: password
    });

    return response;
  },
  logout: async() => {
    return await api.get('/logout');
  },
  forgotten_password: async(email) => {
    return await api.post('/forgotten-password/request/', {
      email: email
    });
  },
  reset_password_verify_token: async(email,token) => {
    return await api.post('/reset-password/verify-token/', {
      email: email,
      token: token,
    });
  },
  reset_password: async(email,token,password) => {
    return await api.post('/reset-password/', {
      email: email,
      token: token,
      password: password,
    });
  },
  register_password_verify_token: async(id,token) => {
    return await api.post('/register-password/verify-token/', {
      id: id,
      token: token,
    });
  },
  register_password: async(id,token,password) => {
    return await api.post('/register-password/', {
      id: id,
      token: token,
      password: password,
    });
  },
  registerLog: async(params, token) => {
    let aux_api = {...api};
    aux_api.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
  });
    return await aux_api.post('/access-logs', params);
  },
  generateAutoLoginToken: async(params) => {
    return await api.get('/generate-auto-login-token/', params);
  },
  autoLogin: async(token)=>{
    return await api.post('/auto-login',{token});
  },
  get_auth:() => {
    return api.get('/get-auth');
  }
};

export default LoginService;